module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch2",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('p', {
    staticClass: "sp-ch",
    attrs: {
      "id": "ch2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_c('span', {
    attrs: {
      "aria-label": "7",
      "id": "pg_7",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("AS SOON AS WATANABE STICKS HIS HEAD OUT,")]), _vm._v(" a torrent of feet engulfs him. He takes a deep breath before emerging. He still has the feeling that the world is swaying slightly, that every object emits the memory of its instability.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fortunately, everything outside appears more or less in its place. He hadn’t been at all sure of this. The force of the jolts made him fear the worst.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It’s cold for March: the hunched shoulders act as a thermometer. On some corners the traffic is at a standstill; at others it is overflowing. Sirens wail in all directions. Lines are snaking around the few vehicles still running. Anyone would think that, in a matter of minutes, the population had multiplied.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The entire city has reverted to an earlier state, before the new road system existed. Its arteries are narrowing. Its circulation has collapsed. After many years—more than he dare count—Mr. Watanabe feels once more that, rather than protecting him, the crowd is crushing him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He tries to calm down and assess the situation. Despite his fatigue, he decides to make his own way home. His neighborhood isn’t all that far away. If he keeps up a brisk pace, he should reach Shinjuku before sunset.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("People are occupying the space in a new, or rather a very old, way: with the visceral sense of those who can rely only on their bodies. Pedestrians walk down the middle of the avenues, a tiny displacement that to Watanabe seems radical.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("These encounters and passing collaborations have an air of shipwreck and rescue. A sudden solidarity disputes distances.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Under normal circumstances, he reflects, isolation offsets overpopulation. And yet that afternoon, several strangers ask how he is, he asks others, and they in turn ask others. Fear is a twisted form of love.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("There is still no phone coverage, or at least he can’t make any calls on his device. The emergency has prompted Wi-Fi providers to clear their "), _c('span', {
    attrs: {
      "aria-label": "8",
      "id": "pg_8",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("networks. He sees many people walking and checking their phones: he can read the news on their faces. Envious of their ability to navigate the virtual world at the same time as the public thoroughfares, Mr. Watanabe tries instead to listen to the radio. He pats his pockets. And discovers he has lost his earbuds.")])]), _vm._v(" "), _c('hr', {
    staticClass: "transition"
  }), _vm._v(" "), _c('p', {
    staticClass: "SB1"
  }, [_vm._v("As if the movement of the earth’s plates had disrupted the clocks, the lights in Tokyo are dimming early. The contrast is so startling, he thinks, that each place ought to have one name in daylight and another in darkness. Many stores have closed. People are stocking up on food and batteries. The bigger the city, the greater its dread of the dark.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Mr. Watanabe remembers when, in his youth, they abolished height restrictions on buildings. To own the air became more important than to own the ground. People protested, demanding their right to the sun. And so the Sunlight Act was passed, thanks to which buildings started to be erected at an angle.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The city’s obsession, its nervous system, is prevention. Containment. Isolation. Ditches. Firebreaks. Anti-seismic constructions. An entire urban plan based on future disasters. The result is a dense weight of trust on a surface of fear. With this in mind, Watanabe stops off at a supermarket. He enters with a very specific objective.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("When he locates the toilet paper shelf, he discovers there isn’t any. He notices that the people gathering the last rolls are more or less his age. On his way out, he sees that stocks of a second product have been exhausted. Diapers. Senescence and infancy are united by the bathroom.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The advertisements on the facades of buildings have vanished. Today, for the first time since his return, the streets are naked.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It no longer resembles Tokyo. As he raises his eyes, only the sky is shining.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Observing people’s necks craned in surprise, Mr. Watanabe realizes how seldom he looks upward. The city center, he reasons, is designed to protect us from the heavens. And yet, the instinct to orient oneself by means of them has resurfaced: a hole has appeared through which they can be seen. The glow diminishes drop by drop, an ocean seeping out through a grating.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "aria-label": "9",
      "id": "pg_9",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Suddenly, the murmurs change in tone. The rumor spreads through the crowd like a current along a cable. Watanabe tries to speed up. Bad news is something he prefers to assimilate on his own.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Behind him, growing ever louder, ever closer, he hears the word "), _c('i', [_vm._v("tsunami")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ac7106","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 78
// module chunks = 0